// import clone from 'clone';
import actions from './actions';
const initState = {
  positions: [],
  position: {},
  isDelete: false,
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    // case actions.ADD_SUCCESS:
    //   return {
    //     ...state,
    //     assetcategories: [],
    //   };
    case actions.GET_POSITION_REDUCER: {
      return {
        ...state,
        positions: action.data,
        isDelete: false,
      };
    }
    default:
      return state;
  }
}
